import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Heart, Download, Eye, TrendingUp, Award } from 'lucide-react';

const UserDashboard = ({ watchHistory, favorites, downloads }) => {
  const stats = {
    totalWatched: watchHistory.length,
    totalHours: Math.round(watchHistory.reduce((acc, item) => acc + item.duration, 0) / 60),
    favoritesCount: favorites.length,
    downloadsCount: downloads.length,
    completionRate: Math.round((watchHistory.filter(item => item.progress > 90).length / watchHistory.length) * 100) || 0
  };

  return (
    <div className="p-6 space-y-6">
      <h2 className="text-3xl font-bold text-white">Mi Actividad</h2>
      
      {/* Stats Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-gray-800/50 p-4 rounded-xl border border-gray-700/50"
        >
          <Eye className="w-8 h-8 text-red-400 mb-2" />
          <div className="text-2xl font-bold text-white">{stats.totalWatched}</div>
          <div className="text-gray-400 text-sm">Películas vistas</div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="bg-gray-800/50 p-4 rounded-xl border border-gray-700/50"
        >
          <Clock className="w-8 h-8 text-blue-400 mb-2" />
          <div className="text-2xl font-bold text-white">{stats.totalHours}h</div>
          <div className="text-gray-400 text-sm">Tiempo total</div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-gray-800/50 p-4 rounded-xl border border-gray-700/50"
        >
          <Heart className="w-8 h-8 text-pink-400 mb-2" />
          <div className="text-2xl font-bold text-white">{stats.favoritesCount}</div>
          <div className="text-gray-400 text-sm">En mi lista</div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="bg-gray-800/50 p-4 rounded-xl border border-gray-700/50"
        >
          <Download className="w-8 h-8 text-green-400 mb-2" />
          <div className="text-2xl font-bold text-white">{stats.downloadsCount}</div>
          <div className="text-gray-400 text-sm">Descargas</div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="bg-gray-800/50 p-4 rounded-xl border border-gray-700/50"
        >
          <TrendingUp className="w-8 h-8 text-yellow-400 mb-2" />
          <div className="text-2xl font-bold text-white">{stats.completionRate}%</div>
          <div className="text-gray-400 text-sm">Tasa de finalización</div>
        </motion.div>
      </div>

      {/* Recomendaciones basadas en actividad */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="bg-gray-800/50 p-6 rounded-xl border border-gray-700/50"
      >
        <div className="flex items-center gap-3 mb-4">
          <Award className="w-6 h-6 text-purple-400" />
          <h3 className="text-xl font-semibold text-white">Basado en tu actividad</h3>
        </div>
        <p className="text-gray-400">
          Nuestro sistema está aprendiendo de tus preferencias para recomendarte contenido que te encantará.
        </p>
      </motion.div>
    </div>
  );
};

export default UserDashboard;